import { render, staticRenderFns } from "./UserIntegralRule.vue?vue&type=template&id=1c1afea2&scoped=true&"
import script from "./UserIntegralRule.vue?vue&type=script&lang=js&"
export * from "./UserIntegralRule.vue?vue&type=script&lang=js&"
import style0 from "./UserIntegralRule.vue?vue&type=style&index=0&id=1c1afea2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1afea2",
  null
  
)

export default component.exports